module.exports = __webpack_public_path__ + "static/media/Events-06.7eaf869b.webp";